module.exports = __webpack_public_path__ + "fonts/WorkSans-Black.0c3d7d3.woff2";